import React from 'react';
import NumberFormat from 'react-number-format';
import { useHistory } from "react-router-dom";

export default function Catalog({ highlights, products }) {
	const history = useHistory();
	return (
		<div id="catalogs" className="section-container">
			<div className="container">
				<div className="row gx-2 justify-content-center">
					{highlights.results.map((p, _i) => {
						let nextLink = p?.code ? '/produk/' + p?.code : ''
						let hasDiscount = p?.discount_rate > 0;
						let net_price = hasDiscount ? p?.unit_price.min * (1 - (p?.discount_rate / 100)) : p?.unit_price.min;
						return (
							<div key={p?.id} className="relative transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300 w-[150px] xs:w-[174px] sm:w-[195px]" style={{ paddingBottom: 10 }}>
								{hasDiscount && (
									<div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-2 py-1 mr-1 rounded-tr rounded-bl z-10">
										-{Math.round(p?.discount_rate)}%
									</div>
								)}
								<button className='shadow' onClick={() => history.push(nextLink)} style={{ background: 'none', border: 'none', borderRadius: 6, padding: 0 }}>
									<div style={{ background: 'var(--bs-component-bg)', borderRadius: 6, border: '1px solid var(--bs-component-border-color)' }}>
										<img src={p?.image?.url} alt="" style={{ objectFit: 'contain', width: '100%', borderTopLeftRadius: 6, borderTopRightRadius: 6 }} />
										<div style={{ padding: 10, textAlign: 'center' }}>
											<h4 style={{ maxHeight: 36, fontSize: 13 }}>{p?.name}</h4>
											{hasDiscount && (
												<div style={{ fontSize: 12, fontWeight: 600 }}><span style={{ textDecoration: 'line-through' }}><NumberFormat value={p?.unit_price?.min} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} prefix={'Rp '} /></span></div>
											)}
											<div style={{ fontSize: 16, fontWeight: 600, color: 'var(--bs-app-theme)' }}><NumberFormat value={net_price} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} prefix={'Rp '} /></div>
											<div style={{ fontSize: 11 }}>{p?.type == 'ready_stock' ? 'Terjual ' + p?.quantity?.out || 0 + ' Pcs' : 'Pre Order'}</div>
											{p?.type == 'ready_stock' && <div style={{ fontSize: 11 }}>Tersedia {p?.quantity?.available || 0} Pcs</div>}
										</div>
									</div>
								</button>
							</div>
						)
					})}
					{products.results.filter((product) => product?.quantity?.available > 0).map((p, _i) => {
						let nextLink = p?.code ? '/produk/' + p?.code : '';
						let hasDiscount = p?.discount_rate > 0;
						let net_price = hasDiscount ? p?.unit_price.min * (1 - (p?.discount_rate / 100)) : p?.unit_price.min;

						return (
							<div key={p?.id} className="relative transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300 w-[150px] xs:w-[174px] sm:w-[195px]" style={{ paddingBottom: 10 }}>
								{hasDiscount && (
									<div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-2 py-1 mr-1 rounded-tr rounded-bl z-10">
										-{Math.round(p?.discount_rate)}%
									</div>
								)}
								<button className='shadow' onClick={() => history.push(nextLink)} style={{ background: 'none', border: 'none', borderRadius: 6, padding: 0 }}>
									<div style={{ background: 'var(--bs-component-bg)', borderRadius: 6, border: '1px solid var(--bs-component-border-color)' }}>
										<img src={p?.image?.url} alt="" style={{ objectFit: 'contain', width: '100%', borderTopLeftRadius: 6, borderTopRightRadius: 6 }} />
										<div style={{ padding: 10, textAlign: 'center' }}>
											<h4 style={{ maxHeight: 36, fontSize: 13 }}>{p?.name}</h4>
											{hasDiscount && (
												<div style={{ fontSize: 12, fontWeight: 600, color: '#999' }}>
													<del><NumberFormat value={p?.unit_price?.min} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} prefix={'Rp '} /></del>
												</div>
											)}
											<div style={{ fontSize: 16, fontWeight: 600, color: 'var(--bs-app-theme)' }}>
												<NumberFormat value={net_price} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} prefix={'Rp '} />
											</div>
											<div style={{ fontSize: 11 }}>Terjual {p?.quantity?.out || 0} Pcs</div>
											<div style={{ fontSize: 11 }}>Tersedia {p?.quantity?.available || 0} Pcs</div>
										</div>
									</div>
								</button>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	)
}
